import {useQuery} from "@tanstack/react-query";
import {
    fetchAppSheetOptionsForClient,
    fetchAppSheetOptionsForProjectPosition,
    fetchAppSheetOptionsForProject,
    fetchForTalentAsManager,
    fetchTalentUserStatsForTalentManager,
    fetchNotificationParams,
    fetchSystemNotifications,
    fetchSystemNotification,
    searchTalentForMessaging,
    fetchClients,
    fetchProjectPositions,
} from "../requests/ClientLeadRequests"
import {
    fetchAllSupplierOpportunities,
    fetchAllSupplierTalentResources,
    fetchOpportunityForAgency,
    fetchSupplierDashboard,
    fetchSupplierTalentResource,
    fetchTalentResourcesForJobBoard,
    fetchServiceOfferingTags, fetchPartnerPrograms
} from "../requests/SupplierRequests";
import {
    fetchRecipientUsers,
    fetchSharableForPosition, fetchTalentCandidateScope,
    positionMatches,
    getPositionMatchingTalentCount,
    searchCandidates, searchDeliverablesByDisciplines, searchPositionTemplateTags
} from "../requests/BYORequests";
import {
    fetchClientProjectGroups,
    fetchClientUsers,
    fetchProject,
    fetchTalentPools,
    fetchTalentPoolDetail,
    fetchTalentPoolActiveProjects,
    fetchTalentUserActivePositions,
    searchProjectKeywords,
    searchForTalent,
    fetchGreenlightOptionsForCandidate,
    searchTalentSkills,
    searchTalentBrands,
    searchForTeams,
    searchForSuppliers,
    fetchTalentTimePayments,
    fetchContractProgression,
    fetchProjectBurnSpend,
    fetchClientProjects
} from "../requests/ClientRequests";
import {
    fetchAllServices,
    fetchProjectTemplate,
    fetchServicesByCategory,
    fetchTeamCandidateScope,
    fetchTemplatesFromTags,
    searchProjectTemplateTags,
    teamMatches
} from "../requests/ServiceProjectRequests";
import {
    fetchAllTeamsForTalent,
    fetchJobBoardDetails,
    fetchJobBoardForTalent,
    fetchCoverLettersForTalent,
    fetchOpportunityForTalent,
    fetchTalentNotificationsInfinite,
    fetchTalentNotification,
    searchAllTalentForMemberInvite,
    searchBrands, fetchLatestVideoInterviewForTalent, searchTagsExpertise
} from "../requests/TalentUserRequests";
import {
    fetchClient,
    fetchMeetings,
    fetchTalent,
    fetchTalentTeam,
    fetchTalentReviews,
    fetchTeam,
    markProposalAsViewed, fetchUserNotificationSettings
} from "../requests/SharedRequests";
import QueryOptions from "./QueryOptions";
import {useMemo} from "react";
import {useMount} from "react-use";

const requests = {
    // ClientLead
    'fetchClients': fetchClients,
    'fetchProjectPositions': fetchProjectPositions,
    'fetchAppSheetOptionsForClient': fetchAppSheetOptionsForClient,
    'fetchAppSheetOptionsForProjectPosition': fetchAppSheetOptionsForProjectPosition,
    'fetchAppSheetOptionsForProject': fetchAppSheetOptionsForProject,
    'fetchForTalentAsManager': fetchForTalentAsManager,
    'fetchTalentUserStatsForTalentManager': fetchTalentUserStatsForTalentManager,
    'fetchNotificationParams': fetchNotificationParams,
    'fetchSystemNotifications': fetchSystemNotifications,
    'fetchSystemNotification': fetchSystemNotification,
    'searchTalentForMessaging': searchTalentForMessaging,
    // Supplier/Agency
    'fetchSupplierDashboard': fetchSupplierDashboard,
    'fetchAllSupplierOpportunities': fetchAllSupplierOpportunities,
    'fetchSupplierTalentResource': fetchSupplierTalentResource,
    'fetchAllSupplierTalentResources': fetchAllSupplierTalentResources,
    'fetchTalentResourcesForJobBoard': fetchTalentResourcesForJobBoard,
    'fetchOpportunityForAgency': fetchOpportunityForAgency,
    'fetchServiceOfferingTags': fetchServiceOfferingTags,
    'fetchPartnerPrograms': fetchPartnerPrograms,

    // Client - Project
    'fetchClientProjectGroups': fetchClientProjectGroups,
    'fetchClientUsers': fetchClientUsers,
    'fetchProject': fetchProject,
    'searchProjectKeywords': searchProjectKeywords,
    'searchForTalent': searchForTalent,
    'searchForTeams': searchForTeams,
    'searchForSuppliers': searchForSuppliers,
    'fetchGreenlightOptionsForCandidate': fetchGreenlightOptionsForCandidate,
    'searchTalentSkills': searchTalentSkills,
    'searchTalentBrands': searchTalentBrands,

    'fetchClientProjects': fetchClientProjects,

    // Client - Financials
    'fetchTalentTimePayments': fetchTalentTimePayments,
    'fetchContractProgression': fetchContractProgression,
    'fetchProjectBurnSpend': fetchProjectBurnSpend,

    // Client - Service/Teams
    'fetchAllServices': fetchAllServices,
    'fetchServicesByCategory': fetchServicesByCategory,
    'teamMatches': teamMatches,
    'fetchTeamCandidateScope': fetchTeamCandidateScope,
    'fetchTemplatesFromTags': fetchTemplatesFromTags,
    'searchProjectTemplateTags': searchProjectTemplateTags,
    'fetchProjectTemplate': fetchProjectTemplate,

    // Client - BYO/ProjectPosition
    'positionMatches': positionMatches,
    'getPositionMatchingTalentCount': getPositionMatchingTalentCount,
    'fetchSharableForPosition': fetchSharableForPosition,
    'searchDeliverablesByDisciplines': searchDeliverablesByDisciplines,
    'fetchTalentCandidateScope': fetchTalentCandidateScope,
    'searchCandidates': searchCandidates,
    'fetchRecipientUsers': fetchRecipientUsers,
    'searchPositionTemplateTags': searchPositionTemplateTags,

    // Talent
    'fetchOpportunityForTalent': fetchOpportunityForTalent,
    'fetchCoverLettersForTalent': fetchCoverLettersForTalent,
    'fetchJobBoardForTalent': fetchJobBoardForTalent,
    'fetchJobBoardDetails': fetchJobBoardDetails,
    'fetchAllTeamsForTalent': fetchAllTeamsForTalent,
    'fetchTalentNotificationsInfinite': fetchTalentNotificationsInfinite,
    'fetchTalentNotification': fetchTalentNotification,
    'fetchLatestVideoInterviewForTalent': fetchLatestVideoInterviewForTalent,
    'searchTagsExpertise': searchTagsExpertise,
    'searchAllTalentForMemberInvite': searchAllTalentForMemberInvite,
    'searchBrands': searchBrands,

    // SHARED
    'fetchMeetings': fetchMeetings,
    'markProposalAsViewed': markProposalAsViewed,
    'fetchClient': fetchClient,
    'fetchTeam': fetchTeam,
    'fetchTalentTeam': fetchTalentTeam,
    'fetchTalent': fetchTalent,
    'fetchTalentPools': fetchTalentPools,
    'fetchTalentPoolDetail': fetchTalentPoolDetail,
    'fetchTalentPoolActiveProjects': fetchTalentPoolActiveProjects,
    'fetchTalentUserActivePositions': fetchTalentUserActivePositions,
    'fetchTalentReviews': fetchTalentReviews,
    'fetchUserNotificationSettings': fetchUserNotificationSettings
}

const useAPI = (key= [] || '', queryOptions = {}) => {

    const queryKey = TB.isString(key) ? [key] : key;
    const lookup = queryKey[0]
    const request = requests[lookup]

    const options = useMemo(() => {
        let handlers = {
            onError: async (error) => {
                console.error(`on${TB.upperFirst(lookup)}Error`, error);
            },
            onSuccess: async (data) => {
                console.log(`on${TB.upperFirst(lookup)}Success`, data);
            },
        };
        if (QueryOptions[lookup]) {
            handlers = {
                ...handlers,
                ...QueryOptions[lookup]
            }
        }
        return {
            ...handlers,
        }
    }, [lookup]);

    useMount(() => {
        if (!request) {
            console.error(`Request not found`, queryKey)
        }
    })
    if (!request) {
        return {}
    }
    return useQuery(
        queryKey,
        request,
        {...options, ...queryOptions}
    )
}

export {
    useAPI
};